const trustItems = [
  { icon: "ri-shield-check-line", label: "Fully Alarmed Facility" },
  { icon: "ri-temp-cold-line", label: "Climate Controlled" },
  { icon: "ri-lock-2-line", label: "Private Controlled Access" },
  { icon: "ri-medal-line", label: "Trusted by Collectors" },
];

export default function TrustBar() {
  return (
    <section className="bg-charcoal-200 border-y border-gold/20">
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <div className="grid grid-cols-2 lg:grid-cols-4">
          {trustItems.map((item, idx) => (
            <div
              key={item.label}
              className={`flex items-center gap-4 py-6 px-6 ${
                idx < trustItems.length - 1 ? "lg:border-r border-white/10" : ""
              }`}
            >
              <div className="w-10 h-10 flex items-center justify-center flex-shrink-0">
                <i className={`${item.icon} text-2xl text-gold`}></i>
              </div>
              <span className="font-sans text-sm text-white font-medium tracking-wide leading-tight">
                {item.label}
              </span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
